import {CancelInterviewType} from 'Interfaces'
import {connect} from 'react-redux'

import {AppDispatch} from 'Store'
import {cancelInterviewInvitation} from 'Store/Actions'
import {ModalCancelInterview} from './ModalCancelInterview'

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  cancelInterviewInvitation: (payload: CancelInterviewType) =>
    dispatch(cancelInterviewInvitation(payload)),
})

export const ModalCancelInterviewContainer = connect(
  null,
  mapDispatchToProps
)(ModalCancelInterview)
